import { OAuthUserInfo } from '@mybiogen/auth-openid';
import { isEmpty } from 'lodash';
import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../MoreActionsMenu/MoreActionsMenu.styles';
import MoreActionsMenuItem from '../MoreActionsMenu/MoreActionsMenuItem';
import { buttonStyle } from './UserProfile.style';
import { getConfigVar } from 'config/config';
import useAuth from 'hooks/useAuth';
import Box from 'yoda-ui/components/Box';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';
import IconButton from 'yoda-ui/components/Icons/IconButton';
import Menu from 'yoda-ui/components/Menu';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const isLast = (index: number, arr: unknown[]) => index >= arr.length - 1;

const UserProfile: FC<{ user: OAuthUserInfo | null | undefined }> = ({ user }) => {
  const { t } = useTranslation();
  const { handleLogin, handleLogout } = useAuth();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const menuItemConfigs = [
    {
      label: t('actions_go_to_home_page_label'),
      hideItem: false,
      onClick: () => { window.location.href = getConfigVar('REACT_APP_BACKOFFICE_HOMEPAGE_URI'); },
    },
    {
      label: t('actions_logout_label'),
      hideItem: isEmpty(user),
      onClick: () => { handleLogout(); },
    },
    {
      label: t('actions_login_label'),
      hideItem: !isEmpty(user),
      onClick: () => { handleLogin(); },
    },
  ];

  const menuItems = menuItemConfigs.map((menuItemConfig, index) => (
    menuItemConfig?.hideItem ? null : (<MoreActionsMenuItem
      key={ menuItemConfig?.label }
      menuItemConfig={ menuItemConfig }
      isLast={ isLast(index, menuItemConfigs) }
      closeMenu={ () => setOpen(false) }
    />)
  ));

  return (
    <>
      <Box marginRight={ YodaSpacing.none } marginY='0'>
        <IconButton
          ref={ buttonRef }
          onClick={ () => setOpen(true) }
          sx={ buttonStyle }
        >
          <Icon
            name={ Icons.user }
            fontSize='small'
          />
        </IconButton>
        <Menu
          anchorOrigin={
            {
              vertical: 'bottom',
              horizontal: 'center',
            }
          }
          transformOrigin={
            {
              vertical: 'top',
              horizontal: 'center',
            }
          }
          sx={ styles.menu }
          open={ open }
          onClose={ () => setOpen(false) }
          anchorEl={ buttonRef.current }
        >
          { menuItems }
        </Menu>
      </Box>

    </>
  );
};
export default UserProfile;
